(ns ui.view.card.activities.view
  (:require
   [ui.util :as uu]
   [common.util :as cu]
   [re-frame.core :as rf]
   [react :as React]
   [ui.view.card.activities.sub :as sub]
   [ui.view.card.activities.event :as event]
   [ui.view.card.sub :as common-card-sub]
   [ui.view.card.event :as common-card-event]
   [ui.components.rich-text.tiptap :as tiptap]
   [ui.components.skeleton.view :as skeleton]
   [ui.components.button.view :as button]
   [common.localization :as loc]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.view.card.shared-components.card-title :as card-title]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.card.shared-components.full-screen-card :as full-screen-card]
   [ui.view.card.shared-components.view :as card-shared]
   [reagent.core :as r]
   [oops.core :as oops]
   [frontend.view.modals.email-viewer.view :as email-viewer-modal]
   [frontend.view.modals.email-viewer.events :as email-events]

    ;; TODO remove these
   [frontend.routing :as routing]
   [frontend.utils :as fu]
   [common.features.plan :as plan]
   [basic-components.field-editor :as field-editor]
   [frontend.actions.email :as actions-email]
   [frontend.state.current-session :as session]
   [frontend.view.modals.events :as modals]
   [frontend.view.entity-viewers.events.email-editor :as email-editor]
   [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [frontend.view.modals.email-editor.view :as email-editor-modal]
   [frontend.view.modals.value-creation.view :as value-creation]
   [frontend.view.entity-viewers.activity.events :as legacy-events]
   [frontend.actions.attachment :as legacy-attachment-actions]
   [clojure.string :as string]))

(defn loading-view
  [{:keys [full-screen?]}]
  [:div
   {:class (uu/cm "mt-2 flex flex-col gap-5 pb-5"
                  (when full-screen?
                    "p-5"))}
   [:div
    {:class "flex gap-2"}
    (->> (range 3)
         (map (fn [idx]
                ^{:key (str "h-" idx)}
                [skeleton/view
                 {:class "h-6 w-24"}])))]
   [skeleton/view
    {:class "h-10"}]
   [:div
    {:class "flex flex-col gap-2"}
    (->> (range 3)
         (map (fn [idx]
                ^{:key (str "a-" idx)}
                [:div
                 {:class "flex gap-5 h-24"}
                 [:div
                  [skeleton/view
                   {:class "h-8 w-8 rounded-full"}]]
                 [:div
                  {:class "pt-1 flex flex-col gap-4"}
                  [skeleton/view {:class "h-5 w-32"}]
                  [skeleton/view {:class "h-3 w-56"}]]])))]])

(defn loading-error-view
  []
  [:div
   {:class "h-56 flex flex-col items-center justify-center"}
   [:p (loc/tr :error-loading-data)]])

(defn no-results-found-view
  []
  [:div
   {:class "flex justify-center p-5"}
   [:div
    {:class "flex flex-col items-center"}
    [:img {:src "/img/undraw_no_data_qbuo.svg"}]
    [:p
     {:class "font-medium text-lg text-basic-light-text"}
     (loc/tr :no-results-found)]]])

(defn tab-elemement
  [{:keys [label icon selected? on-click]}]
  [:span
   {:class (uu/cm "px-2 pb-1 flex gap-2 items-center text-sm m-0"
                  "text-base-light-text transition-colors"
                  "border border-x-0 border-t-0 border-b-2 border-b-transparent"
                  "cursor-pointer"
                  ""
                  (when-not selected?
                    "hover:text-base-light-text-paler")
                  (when selected?
                    "text-base-regular-text-accent border-base-regular-border-accent"))
    :on-mouse-down   on-click}
   [:i {:class-name (str "fal" " " (name icon))}]
   [:span label]])

(defn add-activity-dropdown
  [{:keys [ctx] :as props}]
  (let [primary-entity @(rf/subscribe [::sub/entity ctx])
        primary-entity-id (:db/id primary-entity)
        ;; TODO: handle value creations
        value-creation? false
        open-modal (fn [entity-type]
                     (modals/open-modal!
                      activity-entity-editor/modal-key
                      {:new-entity-type  entity-type
                       :viewed-entity-id (:db/id primary-entity)
                       :on-success-callback! (fn [resp]
                                               (rf/dispatch-sync [::event/fetch-card-data props]))}))
        send-email
        (fn [_]
          (cond
            (not (plan/available :feature/nylas-integration
                                 @session/tenant
                                 @session/role))
            (modals/open-modal!
             dynamic-modal/modal-key
             {:title               (loc/tr :feature-not-in-use)
              :render-fn           (fn [_]
                                     [email-editor/nylas-promo])
              :show-button?        true
              :button-text         (loc/tr :cancel)
              :custom-validator-fn (constantly false)
              :on-submit!          identity
              :content             email-editor/account-not-connected})

            (not (and (:account/nylas-account-id @session/account)
                      (some #{(:account/nylas-status @session/account)}
                            [nil :nylas.status/active])))
            (modals/open-modal!
             dynamic-modal/modal-key
             {:title               (loc/tr :account-not-connected)
              :render-fn           (fn [_]
                                     [email-editor/account-not-connected])
              :show-button?        true
              :button-text         (loc/tr :cancel)
              :custom-validator-fn (constantly false)
              :on-submit!          identity
              :content             email-editor/account-not-connected})

            (and (plan/available :feature/nylas-integration
                                 @session/tenant
                                 @session/role)
                 (:account/nylas-account-id @session/account)
                 (some #{(:account/nylas-status @session/account)}
                       [nil :nylas.status/active]))
            (do
              (modals/open-modal!
               email-editor-modal/modal-key
               {:title-text         [:span (loc/tr :mail-from)
                                     [:span
                                      (:account/nylas-email
                                       @session/account)]]
                :entity-id          primary-entity-id
                :on-primary-submit! (fn [email success! failure!]
                                      (actions-email/*->send-email
                                       email
                                       (fn [resp]
                                         (success! resp)
                                         (rf/dispatch-sync [::event/fetch-card-data props]))
                                       failure!))})
              true)
            :else (do (js/console.log "unhandled condition")
                      false)))]
    [dropdown-menu/view
     {:items
      (concat
       (when value-creation?
         [{:value      :add-value-creation-activity
           :label      (loc/tr :add-value-creation-activity)
           :icon-class "fal fa-coin"
           :on-click   #(modals/open-modal! value-creation/modal-key
                                            {:containing-entity-id primary-entity-id})}])
       [{:value      :add-note
         :label      (loc/tr :add-note)
         :icon-class "fal fa-edit"
         :on-click   #(open-modal :entity.type/note)}
        {:value      :log-call
         :label      (loc/tr :log-call)
         :icon-class "fal fa-phone"
         :on-click   #(open-modal :entity.type/note-call)}
        {:value      :log-meeting
         :label      (loc/tr :log-meeting)
         :icon-class "fal fa-users"
         :on-click   #(open-modal :entity.type/note-meeting)}
        {:value      :log-message
         :label      (loc/tr :log-message)
         :icon-class "fal fa-comments"
         :on-click   #(open-modal :entity.type/note-message)}
        {:value      :log-message
         :label      (loc/tr :send-email)
         :icon-class "fal fa-envelope"
         :on-click   send-email}])
      :props {:align "end"
              :hide-arrow? true}
      :trigger-as-child
      [:span
       [button/sm-secondary-hollow
        {}
        [:span
         [:i.fal.fa-plus]
         (loc/tr :add-activity)]]]}]))

(defn header-row
  [{:keys [ctx collapse-all-activities? toggle-collapse-all-activities preview-mode?] :as props}]
  (let [visible-tabs @(rf/subscribe [::sub/visible-activity-tabs ctx])
        selected-tab @(rf/subscribe [::sub/selected-activity-tab ctx])
        set-selected-tab (fn [tab-value]
                           (rf/dispatch [::event/set-selected-activity-tab ctx tab-value]))]
    [:div
     {:class "flex justify-between border border-x-0 border-t-0"}
     [:div
      {:class "flex"}
      (->> visible-tabs
           (map (fn [{:keys [value] :as tab}]
                  (let [selected? (= value selected-tab)]
                    ^{:key (str "tab-" value)}
                    [tab-elemement
                     (assoc tab
                            :selected? selected?
                            :on-click #(set-selected-tab value))]))))]
     [:div
      {:class "flex items-center gap-2 pb-2 *:text-sm"}
      [button/secondary-open
       {:on-click toggle-collapse-all-activities
        :class "mb-0"}
       (if collapse-all-activities?
         [:<>
          [:i {:class "fal fa-expand-alt font-medium"}]
          (loc/tr :expand-all)]
         [:<>
          [:i {:class "fal fa-compress-alt font-medium"}]
          (loc/tr :collapse-all)])]
      (when-not preview-mode?
        [add-activity-dropdown props])]]))

(defn activity-action-items
  [{:keys [activity-entity primary-entity-id
           local-entities
           collapsed? toggle-collapse-activity] :as props}]
  (let [activity-id (:db/id activity-entity)
        entity-type (:entity/type activity-entity)
        refetch-card-data (fn []
                            (rf/dispatch-sync [::event/fetch-card-data (assoc props :reset? true)]))
        menu-actions
        {:open {:id :view
                :label (loc/tr :view)
                :icon-class "fal fa-eye"
                :on-click #(modals/open-modal!
                            email-viewer-modal/modal-key
                            {:email-id         activity-id
                             :local-entities   local-entities
                             :viewed-entity-id primary-entity-id})}
         :forward    {:label (loc/tr :forward)
                      :icon-class "fal fa-forward"
                      :on-click #(email-events/forward primary-entity-id activity-entity)}

         :reply {:id :reply
                 :label (loc/tr :reply)
                 :icon-class "fal fa-reply"
                 :on-click #(email-events/reply primary-entity-id activity-entity)}

         :reply-all {:id :reply-all
                     :label (loc/tr :reply-all)
                     :icon-class "fal fa-reply-all"
                     :on-click #(email-events/reply primary-entity-id activity-entity)}

         :delete {:id :delete
                  :label (loc/tr :delete)
                  :icon-class "fal fa-trash"
                  :on-click #(legacy-events/dropdown-remove-selected
                              (r/atom @local-entities)
                              activity-id
                              primary-entity-id
                              refetch-card-data
                              identity)}
         :edit {:id :edit
                :label (loc/tr :edit)
                :icon-class "fal fa-edit"
                :on-click
                (fn [_]
                  (case entity-type
                    :entity.type/value-creation
                    (modals/open-modal!
                     value-creation/modal-key
                     {:containing-entity-id primary-entity-id
                      :entity-id activity-id})

                    :entity.type/email
                    (modals/open-modal!
                     email-viewer-modal/modal-key
                     {:email-id         activity-id
                      :local-entities   local-entities
                      :viewed-entity-id primary-entity-id
                      :on-update-email-success refetch-card-data})

                    (modals/open-modal!
                     activity-entity-editor/modal-key
                     {:entity-id           activity-id
                      :entity activity-entity
                      :viewed-entity-id    primary-entity-id
                      :local-entities local-entities
                      :on-success-callback! refetch-card-data
                      :primary-button-text
                      (when (= entity-type  :entity.type/email)
                        (loc/tr :submit))})))}

         :toggle-collapse {:id :toggle-collapse-this
                           :label (if collapsed?
                                    (loc/tr :expand)
                                    (loc/tr :collapse))
                           :icon-class (uu/cm "fal font-medium"
                                              (if collapsed? "fa-expand-alt" "fa-compress-alt"))
                           :on-click toggle-collapse-activity}}
        related-actions
        [:edit :toggle-collapse]

        ;; Leave as reference if needed later
        #_(if-not (= (:entity/type activity-entity) :entity.type/email)
          ;; Note: if :edit is ever used for email, local-entities must be passed to activity-entity-editor:
            [:edit :toggle-collapse]
            (if (and (plan/available :feature/nylas-integration @session/tenant @session/role)
                     (:account/nylas-account-id @session/account))
              [:edit :forward :reply :reply-all :toggle-collapse]
              [:edit :toggle-collapse]))

        menu-items (->> related-actions
                        (select-keys menu-actions)
                        (mapv second))]
    menu-items))

(defn activity-actions
  [{:keys [ctx entity primary-entity-id] :as props}]
  (let  [all-entities-sub (rf/subscribe [::sub/all-entities ctx])
         ;; FIXME: fix this local-entities sub thing somehow. Works but seems sketchy
         items (activity-action-items
                (assoc props
                       :activity-entity entity
                       :primary-entity-id primary-entity-id
                       :local-entities all-entities-sub))]
    [:div
     {:class "flex gap-2"}
     (->> items
          (map (fn [{:keys [id icon-class on-click label]}]
                 ^{:key (str id)}
                 [:span
                  [button/square-secondary-open
                   {:on-click on-click
                    :tooltip label
                    :class "group/action-btn"}
                   [:i {:class (uu/cm icon-class
                                      "text-base-regular-text-paler group-hover/action-btn:text-primary-regular")}]]])))]))

(defn attachment-action-menu
  [{:keys [attachment-id attached-to-primary-entity?
           ctx primary-entity-id] :as props}]
  (let [primary-entity @(rf/subscribe [::sub/entity ctx])
        primary-entity-type (:entity/type primary-entity)
        can-send-email? (and (plan/available :feature/nylas-integration @session/tenant @session/role)
                             (:account/nylas-account-id @session/account))]
    [dropdown-menu/view
     {:items (vec
              (concat
               [{:label (loc/tr :open)
                 :icon-class "fal fa-external-link"
                 :on-click #(fu/open-attachment! attachment-id)}
                {:label (loc/tr :download)
                 :icon-class "fal fa-cloud-download"
                 :on-click #(fu/download-attachment! attachment-id)}]
               (when can-send-email?
                 [{:label (loc/tr :send-file)
                   :icon-class "fal fa-share"
                   :on-click (fn [_]
                               (modals/open-modal!
                                email-editor-modal/modal-key
                                {:title-text         (loc/tr :send-file)
                                 :entity-id          primary-entity-id
                                 :attachments        #{attachment-id}
                                 :on-primary-submit! (fn [email success! error!]
                                                       (actions-email/*->send-email
                                                        email
                                                        (fn [resp]
                                                          (success! resp)
                                                          (rf/dispatch [::event/fetch-card-data props]))
                                                        error!))}))}])
               (when-not attached-to-primary-entity?
                 [{:label (loc/tr :copy-to-specific-entity-attachments
                                  [(cu/str-trim-lcase (loc/tr primary-entity-type))])
                   :icon-class "fal fa-download"
                   :on-click #(legacy-attachment-actions/*->copy-to attachment-id
                                                                    primary-entity-id
                                                                    (fn [_]
                                                                      (rf/dispatch [::event/fetch-card-data props]))
                                                                    (fn [_]))}])))
      :props {:align :end
              :hide-arrow? true}
      :trigger-as-child
      [:button
       {:class (uu/cm "h-6 w-8 flex items-center justify-center cursor-default rounded-md transition-colors"
                      "hover:bg-base-regular")}
       [:i
        {:class "fal fa-angle-down text-md font-medium text-base-light-text-paler"}]]}]))

(defn attachments-tags-and-other-associations
  [{:keys [ctx entity] :as props}]
  (let [activity-id (:db/id entity)
        activity-data @(rf/subscribe [::sub/activity-data ctx activity-id])
        {:keys [attachments tags also-associated-with]} activity-data]
    [:div
     {:class "flex gap-5"}
     (when (seq attachments)
       [:div
        [:p
         {:class "text-sm m-0 text-base-light-text-paler text-nowrap"}
         (if (= (count attachments) 1)
           (loc/tr :attachment)
           (loc/tr :attachment-plural))]

        [:div
         {:class "flex flex-col gap-2"}
         (->> attachments
              (map (fn [{:keys [value label attached-to-primary-entity?]}]
                     (let [attachment-id value]
                       ^{:key (str attachment-id)}
                       [:div
                        {:class "flex items-center gap-3 px-2 py-1 max-w-64 overflow-hidden border rounded items-center  cursor-default group/attachment"}
                        [:div
                         {:class "grow flex items-center gap-2 overflow-hidden"}
                         [:i.fal.fa-paperclip
                          {:class "text-sm m-0 text-base-light-text-paler"
                           :aria-hidden true}]
                         [:p
                          {:class "grow text-sm m-0 truncate"}
                          label]]
                        [:div
                         {:class "shrink-0"}
                         [attachment-action-menu
                          (assoc props
                                 :attachment-id attachment-id
                                 :attachment-label label
                                 :attached-to-primary-entity? attached-to-primary-entity?)]]])))
              (doall))]])
     (when (seq tags)
       [:div
        [:p
         {:class "text-sm m-0 text-base-light-text-paler text-nowrap"}
         (loc/tr :tags)]
        [:div
         {:class "flex gap-2 flex-wrap"}
         (->> tags
              (map
               (fn [{:keys [value label]}]
                 ^{:key (str "tag-" value)}
                 [:div
                  {:class "py-1 px-3 border rounded-full bg-base-gloomy whitespace-nowrap"}
                  [:p
                   {:class "text-xs m-0 text-base-gloomy-text"}
                   label]])))]])
     (when (seq also-associated-with)
       [:div
        [:p
         {:class "text-sm m-0 text-base-light-text-paler text-nowrap"}
         (loc/tr :associated-also-with)]
        [:div
         {:class "flex items-center gap-1 flex-wrap"}
         (->> also-associated-with
              (map (fn [{:keys [value label icon]}]
                     ^{:key (str value)}
                     [:a
                      {:class (uu/cm "group transition-colors px-3 py-1 border bg-base-light hover:bg-base-regular rounded-full flex gap-2 items-center overflow-hidden select-none cursor-pointer whitespace-nowrap"
                                     "has-[>button:hover]:bg-base-light")
                       :on-click #(routing/open-entity value)}
                      (when icon
                        [:i {:class (uu/cm "fal" icon "text-xs m-0 ")}])
                      [:span
                       {:class "text-xs m-0"}
                       label]])))]])]))

(defn activity-item-left
  [{:keys [ctx last-item? entity]}]
  (let [activity-id (:db/id entity)
        activity-data @(rf/subscribe [::sub/activity-data ctx activity-id])
        {:keys [icon]} activity-data]
    [:div
     {:class "flex flex-col items-center"}
     [:div
      {:class "bg-secondary-regular rounded-full w-7 h-7 flex items-center justify-center"}
      [:i
       {:class (uu/cm "fal" icon "text-secondary-regular-text text-sm m-0")}]]
     (when-not last-item?
       [:div
        {:class "grow w-0.5 bg-base-regular-border-paler"}])]))

(defn activity-item-header
  [{:keys [entity ctx toggle-collapse-activity] :as props}]
  (let [activity-id (:db/id entity)
        activity-data @(rf/subscribe [::sub/activity-data ctx activity-id])
        {:keys [title date]} activity-data]
    [:div
     {:class "flex justify-between items-center  "}
     [:p
      {:class "text-base-regular-text-paler text-sm m-0 cursor-pointer hover:text-base-regular-text"
       :on-click toggle-collapse-activity}
      (str date " | " title)]
     [:div
      {:class "flex gap-2 items-center"}
      [activity-actions props]]]))

(defn activity-content
  [{:keys [ctx entity] :as props}]
  (let [activity-id (:db/id entity)
        activity-data @(rf/subscribe [::sub/activity-data ctx activity-id])
        {:keys [content]} activity-data]
    [:div
    ;; HACK: Fix border and too much padding on rich text viewer
     {:class "[&_.ProseMirror]:p-0 [&_.ProseMirror]:border-0"}
     [tiptap/viewer {:value content}]]))

(defn activity-element
  [{:keys [entity collapsed?] :as props}]
  [:div
   {:class "flex items-stretch gap-5 h-full overflow-hidden"}
   [activity-item-left props]
   [:div
    {:class "pb-6 grow flex flex-col h-full overflow-hidden"}
    [activity-item-header props]
    (when-not collapsed?
      [:<>
       [activity-content props]
       [attachments-tags-and-other-associations props]])]])

(defn filter-by-tags-dropdown
  [_props]
  (let [local-state (r/atom {})]
    (fn [{:keys [ctx]}]
      (let [value @(rf/subscribe [::sub/selected-activity-tag-filters ctx])
            options @(rf/subscribe [::sub/activity-tag-filter-options])
            set-filters (fn [tag-ids]
                          (rf/dispatch [::event/set-activity-tag-filters ctx tag-ids]))]
        [field-editor/view
         {:editor/type  :editor.type/multi-select
          :value        value
          :state-atom   local-state
          :placeholder  (loc/tr :filter-activity-by-tag)
          :value-type   :number
          :attribute    :selected-tags
          :label        ""
          :hide-label?  true
          :on-save!     (fn [e new-value clear-cb!]
                          (set-filters new-value)
                          (when clear-cb!
                            (clear-cb!)))
          :drag-options {:hide-drag-area? true}
          :options      options}]))))

(defn content-view-header
  [props]
  [:div
   {:class "flex flex-col gap-3"}
   [header-row props]
   [filter-by-tags-dropdown props]])

(defn full-screen-content-view-inner
  [{:keys [ctx entity-id
           set-header-ref set-list-ref cache on-scroll
           toggle-collapse-activity
           state-atom
           recompute-all-row-heights] :as props}]
  (let [selected-tab @(rf/subscribe [::sub/selected-activity-tab ctx])
        visible-activities @(rf/subscribe [::sub/visible-activities ctx])
        last-activity-index (dec (count visible-activities))
        recompute-trigger-key (->> visible-activities
                                   (map :db/id)
                                   (string/join "-")
                                   (str selected-tab "-"))]
    (react/useEffect
     (fn []
       (recompute-all-row-heights)
       (constantly true))
     (clj->js [recompute-trigger-key]))

    [:div
     {:class "flex flex-col h-full overflow-hidden relative overflow-y-auto"}
     [:div
      {:ref set-header-ref
       :class "relative p-5 z-10 transition-shadow data-[scrolled=true]:shadow data-[scrolled=true]:shadow-md"}
      [content-view-header props]]
     [:div
      {:class "grow overflow-hidden"}
      [:> js/ReactVirtualized.AutoSizer
       (fn [js-autosizer-props]
         (let [list-height (oops/oget js-autosizer-props "height")
               list-width (oops/oget js-autosizer-props "width")]
           (r/as-element
            [:> js/ReactVirtualized.List
             {:ref set-list-ref
              :height list-height
              :width list-width
              :row-count (count visible-activities)
              :row-height (.-rowHeight cache)
              :row-width list-width
              :on-scroll on-scroll
              :overscanRowCount 5
              :deferred-measurement-cache cache
              :noRowsRenderer
              (fn [_]
                (r/as-element
                 [no-results-found-view]))
              :row-renderer
              (fn [js-row-args]
                (let [{:keys [key parent style index]} (js->clj js-row-args :keywordize-keys true)
                      activity-entity (nth visible-activities index)
                      activity-id (:db/id activity-entity)
                      state @state-atom
                      explicitly-set-collapsed-state? (contains? (:collapse-activity state) activity-id)
                      collapsed? (if explicitly-set-collapsed-state?
                                   (get-in state [:collapse-activity activity-id])
                                   (get state :collapse-all-activities?))]
                  (r/as-element
                   [:> js/ReactVirtualized.CellMeasurer
                    {:cache        cache
                     :column-index 0
                     :key          key
                     :style        style
                     :parent       parent
                     :row-index    index}
                    [:div
                     {:style style
                      :class "px-5"}
                     [activity-element
                      (assoc props
                             :entity activity-entity
                             :last-item? (= index last-activity-index)
                             :primary-entity-id entity-id
                             :collapsed? collapsed?
                             :toggle-collapse-activity #(toggle-collapse-activity index activity-id))]]])))}])))]]]))

(defn full-screen-content-view
  [{:keys [ctx]}]
  (let [initial-collapse-state @(rf/subscribe [::sub/collapse-activity-state ctx])
        initial-collapse-all? @(rf/subscribe [::sub/collapse-all-activities? ctx])
        state-atom (r/atom {:collapse-all-activities? initial-collapse-all?
                            :collapse-activity initial-collapse-state})
        list-ref-atom (atom nil)
        header-ref-atom (atom nil)
        cache (js/ReactVirtualized.CellMeasurerCache.
               #js {:defaultHeight 200
                    :fixed-width   true
                    :fixedWidth    true})
        recompute-all-row-heights (fn []
                                    (when-let [list-ref @list-ref-atom]
                                      (let [recompute-fn (oops/oget list-ref "recomputeRowHeights")
                                            clear-cache-fn (oops/oget cache "clearAll")]
                                        (.call clear-cache-fn cache)
                                        (.call recompute-fn list-ref 0))))
        recompute-row-heights-after (fn [item-index]
                                      (when-let [list-ref @list-ref-atom]
                                        (let [recompute-fn (oops/oget list-ref "recomputeRowHeights")
                                              clear-cache-fn (oops/oget cache "clear")]
                                          (.call clear-cache-fn cache item-index)
                                          (.call recompute-fn list-ref item-index))))
        on-scroll (fn [e]
                    (let [scroll-top (oops/oget e "scrollTop")
                          scrolled? (< 30 scroll-top)
                          testi false ;; TODO DELETE
                          header-ref @header-ref-atom]
                      (when header-ref
                        (oops/ocall header-ref "setAttribute"  "data-scrolled" (if scrolled? "true" "false")))))
        toggle-collapse-all-activities (fn []
                                         (let [prev-collapse-all? (:collapse-all-activities? @state-atom)]
                                           (swap! state-atom assoc
                                                  :collapse-all-activities? (not prev-collapse-all?)
                                                  :collapse-activity {})
                                           (recompute-all-row-heights)
                                           (rf/dispatch [::event/toggle-collapse-all-activities ctx])))
        toggle-collapse-activity (fn [index activity-id]
                                   (let [state @state-atom
                                         explicitly-set? (contains? (:collapse-activity state) activity-id)
                                         prev-value (if explicitly-set?
                                                      (get-in state [:collapse-activity activity-id])
                                                      (:collapse-all-activities? state))]
                                     (swap! state-atom assoc-in [:collapse-activity activity-id] (not prev-value))
                                     (recompute-row-heights-after index)
                                     (rf/dispatch [::event/toggle-collapse-activity ctx activity-id])))]
    (r/create-class
     {:component-did-mount (fn [_]
                             (.addEventListener js/window "resize" recompute-all-row-heights))
      :component-will-unmount (fn [_]
                                (.removeEventListener js/window "resize" recompute-all-row-heights))
      :reagent-render
      (fn [props]
        [:f> full-screen-content-view-inner
         (merge props
                {:cache cache
                 :on-scroll on-scroll
                 :state-atom state-atom
                 :set-header-ref (fn [ref] (reset! header-ref-atom ref))
                 :set-list-ref (fn [ref] (reset! list-ref-atom ref))
                 :toggle-collapse-activity toggle-collapse-activity
                 :collapse-all-activities? (:collapse-all-activities? @state-atom)
                 :toggle-collapse-all-activities toggle-collapse-all-activities
                 :recompute-all-row-heights recompute-all-row-heights})])})))

(defn content-view
  [{:keys [entity-id full-screen? ctx] :as props}]
  (let [visible-activities @(rf/subscribe [::sub/visible-activities ctx])
        visible-count (count visible-activities)
        rendered-activities (if full-screen?
                              visible-activities
                              (take 5 visible-activities))
        rendered-count (count rendered-activities)
        toggle-collapse-activity (fn [activity-id]
                                   (rf/dispatch-sync [::event/toggle-collapse-activity ctx activity-id]))
        collapse-all-activities? @(rf/subscribe [::sub/collapse-all-activities? ctx])
        toggle-collapse-all-activities #(rf/dispatch [::event/toggle-collapse-all-activities ctx])]
    [:div
     {:class "h-full overflow-hidden relative overflow-y-auto"
      :on-scroll (fn [e]
                   (let [target (.. e -target)
                         scroll-top (oops/oget target "scrollTop")
                         scrolled? (< 30 scroll-top)
                         header (.-firstChild target)]
                     (.setAttribute header "data-scrolled" (if scrolled? "true" "false"))))}
     [:div
      {:class (uu/cm ""
                     (when full-screen?
                       (uu/cm "p-5 sticky z-50 top-0 w-full block bg-base-light transition-shadow"
                              "data-[scrolled=true]:shadow data-[scrolled=true]:shadow-md")))}
      [content-view-header
       (assoc props
              :collapse-all-activities? collapse-all-activities?
              :toggle-collapse-all-activities toggle-collapse-all-activities)]
      [:div
       {:class (uu/cm "pt-3"
                      (when full-screen? "px-5"))}
       (if (empty? visible-activities)
         [no-results-found-view]
         [:<>
          [:div
           {:class "flex flex-col"}
           (->> rendered-activities
                (map-indexed
                 (fn [idx entity]
                   (let [activity-id (:db/id entity)
                         collapsed? @(rf/subscribe [::sub/collapse-activity? ctx activity-id])
                         last-item? (= idx (dec visible-count))]
                     ^{:key (str "activity-" activity-id "-" visible-count)}
                     [activity-element
                      (assoc props
                             :entity entity
                             :last-item? last-item?
                             :primary-entity-id entity-id
                             :collapsed? collapsed?
                             :toggle-collapse-activity #(toggle-collapse-activity activity-id)
                             :toggle-collapse-all-activities toggle-collapse-all-activities)])))
                (doall))]
          (when (< rendered-count visible-count)
            [:button
             {:on-click #(rf/dispatch [::common-card-event/toggle-full-screen ctx])
              :class "text-base-light-text-paler rounded px-3 py-2 hover:bg-base-regular transition-colors"}
             (loc/tr :show-more)])])]]]))

;; TODO: full screen error and loading views
(defn card-body
  [{:keys [full-screen? ctx] :as props}]
  (let [loading? @(rf/subscribe [::sub/loading? ctx])
        loading-error? @(rf/subscribe [::common-card-sub/loading-error? ctx])]
    (cond
      loading? [loading-view props]
      loading-error? [loading-error-view]
      full-screen? [full-screen-content-view props]
      :else [content-view props])))

(defn component
  [{:keys [card preview-mode?] :as props}]
  (let [title (:card/title card)]
    [card-container/view
     [:div
      {:class "flex flex-col gap-3"}
      [:div
       {:class "flex justify-between items-center"}
       [card-title/view title]
       (when-not preview-mode?
         [:div
          {:class "opacity-0 group-hover/card:opacity-100 transition-opacity"}
          [card-shared/expand-card props]])]
      [card-body props]]]))

(defn modal-component
  [props]
  [full-screen-card/view
   (merge
    props
    {:content-class "p-0"})
   [card-body props]])

(defn view
  [{:keys [full-screen?] :as props}]
  (if full-screen?
    [modal-component props]
    [component props]))
